export const APP_IDS = {
  CupisDesktop: 3,
  CupisMobile: 28,
  ComDesktop: 2,
  ComMobile: 8,
  ComPWA: 29,
};

export const EVENT_SOURCES = {
  desktop: 'desktop',
  mobile: 'mobile_version',
};

export const DEFAULT_CUPIS_APPVERS = '2.8.31';

export const INPUT_VARIANT = {
  LEGEND: 'legend',
  STACKED: 'stacked',
};
